function u(e, n = 0) {
  if (!e || e.paused || e.ended || e.seeking || e.readyState < 3) return null;
  const t = e.currentTime;
  return Number.isFinite(t) ? t + n : null;
}
function l(e) {
  return e !== null && typeof e == "object" && typeof e.play == "function" && typeof e.pause == "function" && typeof e.stop == "function" && typeof e.seek == "function";
}
function a(e) {
  return e !== null && typeof e == "object" && typeof e.setSource == "function";
}
function f(e) {
  return e !== null && typeof e == "object" && typeof e.setVolume == "function";
}
function o(e) {
  return e !== null && typeof e == "object" && typeof e.isPlaying == "function";
}
function i(e) {
  return e !== null && typeof e == "object" && typeof e.getVolume == "function";
}
function c(e) {
  return e !== null && typeof e == "object" && typeof e.getClockTime == "function";
}
function r(e) {
  return e !== null && typeof e == "object" && typeof e.sampleAt == "function" && typeof e.isSampling == "function";
}
export {
  f as a,
  u as c,
  o as i,
  r as n,
  i as o,
  a as r,
  l as s,
  c as t
};

//# sourceMappingURL=playable-tG_Q2o5X.js.map